module.exports = __webpack_public_path__ + "static/media/29EUNOG19.3244464c.jpg";